import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useAppDispatch } from "@/hooks/store-hooks";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { UserCredentials, SignedInUser } from "@/models/auth";
import { IAuthApi } from "@/api/auth";
import { authActions } from "@/store/reducers/auth.reducer";
import { useToast } from "@/hooks/use-toast";
import { ErrorResponseType } from "@/models/common/error";

export const useSignIn = () => {
  const authApi = useInjection<IAuthApi>(SERVICES_TYPES.AUTH);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { toast } = useToast();
  return useMutation<SignedInUser, ErrorResponseType, UserCredentials>({
    mutationFn: (credentials) => authApi.signIn(credentials),
    onSuccess(data) {
      dispatch(authActions.authenticate(data));
      navigate("/", { replace: true });
    },
    onError(data: ErrorResponseType) {
      toast({
        title: "Sign In Failed",
        description: data.message["en"],
        variant: "error"
      });
    }
  });
};
